import { NgModule } from '@angular/core';

import { FormForCellSignInModule } from '@shared/core/modules/forms/formTypes/forCellSignIn';

import { AuthHeaderModule } from '../../components/authHeader';

import { AuthForCellSignInComponent } from './auth-for-cell-sign-in.shared.component';

@NgModule({
    declarations: [
        AuthForCellSignInComponent
    ],
    imports: [
        AuthHeaderModule,
        FormForCellSignInModule,
    ],
    exports: [
        AuthForCellSignInComponent
    ],
})
export class AuthForCellSignInModule { }
